import { ApiError } from "@/api/client";
import { ErrorBanner } from "@/components/ui";

export const LOCKOUT_MESSAGE = "this change would leave no active user who can manage users and roles";

/** A plain-language next step for the admin 409s whose server message we know. */
export function conflictHelp(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null;
  if (error.message === LOCKOUT_MESSAGE) {
    return "Someone active must keep both user.manage and role.manage. Give another active user a role with both first.";
  }
  if (error.message === "you cannot deactivate your own account") {
    return "Ask another user manager to deactivate this account if it should be.";
  }
  if (/^role is still assigned to \d+ users?/.test(error.message)) {
    return "Remove this role from everyone who holds it, then delete it.";
  }
  return null;
}

/** The server's message, with a plain next step for the 409s we recognise. */
export function ConflictBanner({ error }: { error: unknown }) {
  const help = conflictHelp(error);
  return (
    <>
      <ErrorBanner error={error} />
      {help ? <p className="text-sm text-zinc-700">{help}</p> : null}
    </>
  );
}
